import React, { useState } from 'react'
import { getCompareSimilar } from '../hooks/useCompareSimilar'
import { isDesktop } from "@insight/toolkit-utils";
import { comparisonExperienceFF } from "../shared/getFeatureFlagUtils";


/** CompareSimilar Context */
export const CompareSimilarContext = React.createContext({
  similarProducts: null,
  loading: false
})
CompareSimilarContext.displayName = 'CompareSimilar'

/** CompareSimilar Context Provider
 *
 * Renders a provider containing the current state of compare similar products
 * */
export const CompareSimilarProvider = (props) => {
  // GNA-21905: read once on mount so the conditional hook call stays stable across re-renders.
  const [enabled] = useState(() => isDesktop() && comparisonExperienceFF())
  const [similarProducts, loading] = enabled ? getCompareSimilar() : [null, false]
  return (
    <CompareSimilarContext.Provider value={{ similarProducts, loading }}>
      {props.children}
    </CompareSimilarContext.Provider>
  )
}
